var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4"},[_c('h1',{staticClass:"text-center"},[_vm._v("333333")]),_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"height":"1500px"}},[_c('p',{staticClass:"align-content-center"},[_vm._v(" tttttttttttttttttttttttttttttttttt ")])])])
}]

export { render, staticRenderFns }